import { useEffect, useRef } from 'react';

import { useNpsSurveyContext } from '@web/components/npsScore/NpsSurveyProvider/NpsSurveyProvider';
import { OTHER_INFLUENCE_KEY } from '@web/components/npsScore/constants';

import { Influence } from '../NpsSurveyProvider/npsSurveyProvider.types';

export const useRatingInfluenceStep = () => {
  const commentInputRef = useRef<HTMLTextAreaElement>(null);

  const {
    npsSurveyFormValues: { influence, influenceComment },
    updateNpsValue,
  } = useNpsSurveyContext();

  const isCommentVisible = influence === OTHER_INFLUENCE_KEY;
  const isValid = influence && (!isCommentVisible || influenceComment);

  const setInfluence = (updatedInfluence: Influence) => {
    updateNpsValue({ influence: updatedInfluence });
  };

  const setInfluenceComment = (comment: string) => {
    updateNpsValue({ influenceComment: comment });
  };

  useEffect(() => {
    if (isCommentVisible) {
      commentInputRef.current?.focus();
    }
  }, [isCommentVisible]);

  return {
    commentInputRef,
    influence,
    influenceComment,
    isCommentVisible,
    isValid,
    setInfluence,
    setInfluenceComment,
  };
};
